import { Stack, Group, Text, Badge } from '@repletoryreach/sdk-ui';
import { EntityCardGrid, StatusBadge } from '@repletoryreach/sdk-ui/data-display';
import { formatInteger } from '../../../lib/format';
import { useT } from '../../../i18n/I18nProvider';
import { hasNoConsumers, queueKey, queueTone, type Queue } from './queueState';

const MUTED = 'var(--rr-color-text-muted)';

export function QueuesCards({ rows }: { rows: Queue[] }) {
  const t = useT();
  return (
    <EntityCardGrid<Queue>
      records={rows}
      idAccessor={(r) => queueKey(r)}
      cols={3}
      spacing="md"
      renderCard={(r) => (
        <Stack gap="md">
          <Group justify="space-between" align="baseline" wrap="nowrap">
            <Text role="subtitle" fw={600} truncate><code>{r.name}</code></Text>
            <StatusBadge status={queueTone(r)} size="xs">{r.state ?? t('status.unknown')}</StatusBadge>
          </Group>
          <Text role="caption" c={MUTED}><code>{r.vhost}</code></Text>
          {hasNoConsumers(r) && (
            <Badge size="xs" color="red" variant="light">{t('queues.noConsumersBadge')}</Badge>
          )}
          <Group gap="md" style={{ paddingTop: 8, borderTop: '1px solid var(--rr-color-border)' }}>
            <Stack gap={0}><Text role="caption" c={MUTED}>{t('queues.columns.ready')}</Text><Text role="bodySmall" fw={600}>{formatInteger(r.messages_ready ?? 0)}</Text></Stack>
            <Stack gap={0}><Text role="caption" c={MUTED}>{t('queues.columns.unacked')}</Text><Text role="bodySmall" fw={600}>{formatInteger(r.messages_unacked ?? 0)}</Text></Stack>
            <Stack gap={0}><Text role="caption" c={MUTED}>{t('queues.columns.consumers')}</Text><Text role="bodySmall" fw={600}>{r.consumers}</Text></Stack>
          </Group>
          <Text role="caption" c={MUTED}>{t('queues.list.total', { count: formatInteger(r.messages ?? 0) })}</Text>
        </Stack>
      )}
    />
  );
}
